import { PARTNER_KEY_COOKIE } from '../constants';

// Utils
import Cookies from 'js-cookie';

// Hooks
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';

// Redux
import {
    getPartnerKey,
    getIsPartnerValid,
    validatePartnership,
    getLoading,
} from '../models/referral';

export const useValidatePartnership = () => {
    const dispatch = useDispatch();
    const { query, isReady: isRouterReady } = useRouter();
    const { partnerKey: queryPartnerKey } = query;

    const savedPartnerKey = useSelector(getPartnerKey);
    const isSavedPartnerValid = useSelector(getIsPartnerValid);
    const isValidatingPartner = useSelector(getLoading);

    const cookiePartnerKey = Cookies.get(PARTNER_KEY_COOKIE)?.split('|')?.[0];
    const partnerKeyToValidate = (queryPartnerKey || cookiePartnerKey) as string;

    if (!isRouterReady || isValidatingPartner) {
        return;
    }

    if (savedPartnerKey && isSavedPartnerValid) {
        return;
    } else if (partnerKeyToValidate && partnerKeyToValidate !== savedPartnerKey) {
        dispatch(validatePartnership(partnerKeyToValidate));
    }
};
